import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    blockTextColor: p => p.tertiaryDark,
    background: p => p.tertiaryDark,
    icon: p => `rgba(${hexToRgb(p.primaryLight)}, 1)`,
    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    background: p => p.tertiaryLight,
    blockTextColor: p => p.tertiaryDark,
    icon: p => `rgba(${hexToRgb(p.primaryDark)}, 1)`,
    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    blockTextColor: p => p.tertiaryDark,
    background: p => p.tertiaryExtraLight,
    icon: p => `rgba(${hexToRgb(p.primaryDark)}, 1)`,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
